module.exports = __webpack_public_path__ + "media/images/top/common/img_step03-8a136008c58dbb19cc91c191d92f0758.png";